export const APP = {
  name: "412Level",
  tagline: "Analizza il tuo Instagram e scopri cosa pubblicare dopo.",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "",
  supportEmailActive: process.env.REACT_APP_SUPPORT_EMAIL_ACTIVE === "true",
};

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
